import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var allSetUserByIDSlice = createSlice({
    name: "allSetUserByID",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _allSetUserByIDSlice_actions = allSetUserByIDSlice.actions;
export var fetchData = _allSetUserByIDSlice_actions.fetchData, fetchDataSuccess = _allSetUserByIDSlice_actions.fetchDataSuccess, fetchDataFailure = _allSetUserByIDSlice_actions.fetchDataFailure, resetState = _allSetUserByIDSlice_actions.resetState;
export default allSetUserByIDSlice.reducer;
